"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsoWeekday = void 0;
/**
 * ISO8601 week days.
 *
 * ISO8601 specifies that weeks start with Monday, with Monday and Sunday
 * represented as 1 and 7 respectively.
 *
 * https://en.wikipedia.org/wiki/ISO_week_date
 */
var IsoWeekday;
(function (IsoWeekday) {
    IsoWeekday[IsoWeekday["Monday"] = 1] = "Monday";
    IsoWeekday[IsoWeekday["Tuesday"] = 2] = "Tuesday";
    IsoWeekday[IsoWeekday["Wednesday"] = 3] = "Wednesday";
    IsoWeekday[IsoWeekday["Thursday"] = 4] = "Thursday";
    IsoWeekday[IsoWeekday["Friday"] = 5] = "Friday";
    IsoWeekday[IsoWeekday["Saturday"] = 6] = "Saturday";
    IsoWeekday[IsoWeekday["Sunday"] = 7] = "Sunday";
})(IsoWeekday || (exports.IsoWeekday = IsoWeekday = {}));
//# sourceMappingURL=time.js.map